import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Warrants';

export const WarRoutes = [
  {
    path: '/:program(\\war|payroll)',
    name: 'Warrant/Payroll Register',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/Warrants.vue'),
    children: [
      {
        path: 'reports',
        name: 'Warrant/Payroll Register - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/War/Reports.vue'),
      },
      {
        path: 'transactions',
        name: 'Warrant/Payroll Register - Transactions',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/War/Transactions.vue'),
      },
      {
        path: 'payroll',
        name: 'Payroll Register - Transactions',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/War/Transactions.vue'),
      },
      {
        path: 'browse',
        name: 'Warrant/Payroll Register - Browse',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/War/browse/browse.vue'),
        children: [
          {
            path: 'departments',
            name: 'Warrant/Payroll Register - Departments',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/browse/Departments.vue'),
          },
          {
            path: 'accounts',
            name: 'Warrant/Payroll Register - Accounts',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/browse/Accounts.vue'),
          },
          {
            path: 'whoms',
            name: 'Warrant/Payroll Register - To Whom',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/browse/Whoms.vue'),
          },
        ],
      },
      {
        path: 'utils',
        name: 'Warrant/Payroll Register - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/War/utils/Utils.vue'),
        children: [
          {
            path: 'fundreconciliation',
            name: 'Warrant/Payroll Register - Fund Reconciliation',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/utils/FundRecon.vue'),
            children: [
              {
                path: 'reconTransaction',
                name: 'Warrant/Payroll Register - Reconciliation Transaction',
                meta: {
                  title: DOCUMENT_TITLE,
                },
                component: () => import('../../src/components/War/Utils/FundReconciliation/FundReconciliation.vue'),
              },
              {
                path: 'glFund',
                name: 'Warrant/Payroll Register - GL Fund',
                meta: {
                  title: DOCUMENT_TITLE,
                },
                component: () => import('../../src/components/War/Utils/FundReconciliation/GLFundList.vue'),
              },
            ],
          },
          {
            path: 'createfiscalyear',
            name: 'Warrant/Payroll Register - Create Fiscal Year',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/utils/CreateFiscalYear.vue'),
          },
          {
            path: 'remitwarrants',
            name: 'Warrant/Payroll Register - Remit Warrants',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/War/utils/RemitWarrants.vue'),
          },
        ],
      },
    ],
  },
];

WarRoutes.forEach((element, index) => {
  WarRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(authRoles.WarRead, next);
  };
});

export default WarRoutes;
